// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xjiKN","title":"Header_title__D2QW6","side":"Header_side__1kduI"};